import React, { createContext, Fragment, useEffect, useState } from 'react'
import Fire_base from '../Config/Fire_base'
import LoadingTemplate from '../Components/Templates/Loading'

export const AuthContex = createContext()

export const AuthProvider = ({children}) => {
    const [currentUser, setcurrentUser] = useState(null)
    const [pending, setpending] = useState(true)

    useEffect(()=> {
        Fire_base.auth().onAuthStateChanged((user)=>{
            setcurrentUser(user)
            setpending(false)
        });
    },[]);

    if (pending) {
        return(
        <Fragment>
            <LoadingTemplate/>
        </Fragment>
        )
    }

    return (
        <AuthContex.Provider
            value={{
                currentUser
            }}
        >
            {children}
            {/* children adalah routing di dalah authcotex */}
        </AuthContex.Provider>
    )
}
